var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriveInOutGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 31,
    viewBox: "0 0 45 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__b",
    width: 26.889,
    height: 4.889,
    x: -3.667,
    y: 0,
    rx: 1.222
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0.611 0.611H22.611V4.278H0.611z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#5f00a0",
    strokeWidth: 1.222,
    d: "M0 0L18.333 0 18.333 2.931 0 2.931z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    d: "M1.222 2.444h15.89v26.89H1.221V2.443zm3.667 4.89c-.675 0-1.222.547-1.222 1.222v8.555c0 .675.547 1.222 1.222 1.222h8.555c.675 0 1.223-.547 1.223-1.222V8.556c0-.675-.548-1.223-1.223-1.223H4.89z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5f00a0",
    transform: "translate(1 1) translate(21.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.504 0c.359 0 .65.29.65.649v2.726H2.854V.649c0-.358.291-.649.65-.649zM18.43.26c.36 0 .65.29.65.649v2.725h-1.298V.91c0-.359.29-.65.649-.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.962 25.62c.003.602.009 1.098.016 1.461H4.376v1.474c0 .43-.349.778-.779.778H1.254c-.43 0-.779-.348-.779-.778v-2.513c0-.138-.36-.303-.475-.614v-2.133c0-.264.804-.521.804-.926v-2.327c.51-1.079 1.063-1.878 1.658-2.398V3.958c0-.784.583-1.446 1.361-1.545 3.129-.397 5.515-.596 7.16-.596 1.64 0 4 .198 7.077.594.777.1 1.359.762 1.359 1.545v13.688c.595.52 1.148 1.32 1.658 2.398v2.327c0 .405.804.662.804.926v2.133c-.116.311-.475.476-.475.614v2.513c0 .43-.349.778-.779.778h-2.343c-.43 0-.78-.348-.78-.778V27.08h-6.522c-.007-.363-.014-.86-.02-1.461zM7.139 4.153c-.359 0-.65.29-.65.65 0 .358.291.648.65.648h7.528c.358 0 .649-.29.649-.649 0-.358-.29-.649-.65-.649H7.14zM4.862 7.788c-.402 0-.738.305-.776.705l-.37 3.893c-.003.025-.004.05-.004.074 0 .43.349.779.779.779h13.083c.025 0 .05-.001.074-.004.428-.04.742-.42.701-.849l-.37-3.893c-.038-.4-.374-.705-.776-.705H4.862zm.618 7.476l-.03.002c-.571.044-1 .543-.955 1.115l.4 5.205c.021.27.247.479.518.479h11.239c.271 0 .497-.209.518-.48l.4-5.204.002-.03c.028-.572-.414-1.06-.987-1.087l-5.553-.27-5.552.27zm-3.793 6.022c-.215 0-.39.174-.39.39v.26c0 .214.175.388.39.388h1.298c.215 0 .39-.174.39-.389v-.26c0-.215-.175-.389-.39-.389H1.687zm17.133 0c-.215 0-.39.174-.39.39v.26c0 .214.175.388.39.388h1.298c.215 0 .39-.174.39-.389v-.26c0-.215-.175-.389-.39-.389H18.82zM.91 23.622c-.215 0-.39.175-.39.39v.779c0 .215.175.389.39.389h19.988c.215 0 .39-.174.39-.39v-.778c0-.215-.175-.39-.39-.39H.909z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.21 8.447h1.658c.286 0 .519.232.519.519v2.487c0 .287-.233.519-.52.519h-.81l-.848.847v-.551l.57-.57V8.866h-.57v-.42zM2.696 8.447H1.038c-.286 0-.519.232-.519.519v2.487c0 .287.233.519.52.519h.81l.847.847v-.551l-.57-.57V8.866h.57v-.42z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.903,
    height: 1,
    x: 5.451,
    y: 16.094,
    rx: 0.389
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.383,
    height: 1,
    x: 5.711,
    y: 17.652,
    rx: 0.389
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.864,
    height: 1,
    x: 5.971,
    y: 19.209,
    rx: 0.389
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.345,
    height: 1,
    x: 6.23,
    y: 20.767,
    rx: 0.389
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1) translate(19.556 14.667)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__b"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 25.667,
    height: 3.667,
    x: -3.056,
    y: 0.611,
    stroke: "#5f00a0",
    strokeWidth: 1.222,
    rx: 1.222
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5f00a0",
    strokeWidth: 1.222,
    d: "M-1.222 4.068L1.99.855M4.889 4.068L8.102.855M11 4.068L14.213.855M17.111 4.068L20.324.855",
    mask: "url(#prefix__c)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveInOutGreen);
export default __webpack_public_path__ + "static/media/drive_in_out_green.abd924679997947cb243738528c2541a.svg";
export { ForwardRef as ReactComponent };